/**
 * VNIS Register Form - Wrapper for SelectProvider in workflow
 */
import SelectProvider from './select-provider'
import type { RegisterServiceTemplateProps } from '../types'

const VnisRegisterForm: React.FC<RegisterServiceTemplateProps> = ({
    service,
}) => {
    return (
        <SelectProvider
            service={service}
            serviceTemplate={service?.service_template || ''}
            serviceID={service?.service_id as number}
            serviceUUID={service?.service_creatable_uuid || ''}
        />
    )
}

export default VnisRegisterForm
